import { render, staticRenderFns } from "./Default-layout.vue?vue&type=template&id=4972773d&scoped=true&"
import script from "./Default-layout.vue?vue&type=script&lang=js&"
export * from "./Default-layout.vue?vue&type=script&lang=js&"
import style0 from "./Default-layout.vue?vue&type=style&index=0&id=4972773d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4972773d",
  null
  
)

export default component.exports